export const SET_TOKEN = 'SET_TOKEN'
export const SET_STEPACTIVEINDEX = 'SET_STEPACTIVEINDEX'
export const SET_LOGIN_POP_STATE = 'SET_LOGIN_POP_STATE'
export const SET_CHECKED_EMAIL = 'SET_CHECKED_EMAIL'
export const SET_EMAIL_BIND = 'SET_EMAIL_BIND'
export const SET_USER = 'SET_USER'
export const SET_UID = 'SET_UID'
export const SET_REDIRECT = 'SET_REDIRECT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js